module.exports = __webpack_public_path__ + "img/chinesecompany78.1a48a9c1.png";